import React from 'react';
import { POSITIONS_SETTINGS_FILTERS_SLUGS } from '../../../constants';
import usePositionsSettingsFilterOptions from '../../../hooks/usePositionsSettingsFilterOptions';
import GenericFilter from './GenericFilter';

const PositionsSettingsComplianceFilter = (props) => {
  const options = usePositionsSettingsFilterOptions();

  return (
    <GenericFilter
      {...props}
      titleKey="compliance"
      namePrefix="compliance"
      staticOptions={options[POSITIONS_SETTINGS_FILTERS_SLUGS.compliance]}
    />
  );
};

export default PositionsSettingsComplianceFilter;
